import { Button, Col, Form, InputGroup, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import TableFilterBox from "../organisms/TableFilterBox";
import TableHeader from "../organisms/TableHeader";
import TableFooter from "../organisms/TableFooter";
import styled from "styled-components";
import DataTable from "./DataTable";
import { Link, useLocation, useParams } from "react-router-dom";
import PDFMerger from 'pdf-merger-js';
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideConfirm, showConfirm } from "../../../reducer/confirmSlice";
import DatepickerRange from "../molecules/DatepickerRange";
import { useMutation, useQuery } from "@tanstack/react-query";
import moment from "moment-timezone";
import Loading from "./Loading";
import TablePagination from "../molecules/TablePagination";
import { showAlert } from "../../../reducer/alertSlice";
import axios from "axios";
import SelectBox from "../molecules/SelectBox";
import { useMasking } from "../../common/hook";
import { onlyNumber } from "../../common/util";

const TableWrap = styled.div`
    flex: 1 1;
    display: flex;
    flex-direction: column;

    .data-table {
        flex-grow: 1;
    }
`;

const merger = new PDFMerger();
const ReportManagement = () => {
    const {companyId, branchId} = useParams();
    const location = useLocation();
    const defaultDate = [moment().add(-30, "days").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
    const perPageOptions = useSelector(state => state.perPageOptions);

    const defaultFilter = {
        "companyId": companyId,
        "branchId": branchId == 0 ? "" : branchId,
        "orderField": "reportTime",
        "order": "desc",
        "page": 1,
        "perPage": perPageOptions[0].value,
        "startDate": defaultDate[0],
        "endDate": defaultDate[1],
        "reportId": "",
        "userPhone": "",
        "userName": ""
    };
    
    const dispatch = useDispatch();
    const {masking} = useMasking();

    // (S) state
    const [showReadyPrintModal, setShowReadyPrintModal] = useState(false);
    const [showPdfHistoryModal, setShowPdfHistoryModal] = useState(false);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [reportPw, setReportPw] = useState();
    const [loading, setLoading] = useState(false);
    
    const checkAllRef = useRef();
    // 리포트 
    const [tableData, setTableData] = useState({
        orderField: ["branch", "reportId", "name", "birth", "phone", "reportTime", "printCount", "peportUrl"],
        head: [
        "지점", "리포트 ID", "이름", "생년월일", "휴대폰번호", "측정일시", 
        <>
            PDF 생성
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip>
                        PDF 생성은 리포트 출력을 위해 <br/>1개의 병합된 PDF를 생성한 횟수를 의미합니다.
                    </Tooltip>
                }
            ><svg className="ms-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
            </svg></OverlayTrigger>
        </>
        , 
        <>
            PDF 보기
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip>
                        보기 버튼 클릭 시 해당 리포트를 
                        <br/>새창에서 PDF로 보여줍니다.
                    </Tooltip>
                }
            ><svg className="ms-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
            </svg></OverlayTrigger>
        </>,
        "삭제"
        ],
        body: [],
    });
    // 리포트 병합
    const [reportMergeArr, setReportMergeArr] = useState([]);
    const [reportMergeTable, setReportMergeTable] = useState([]);
    const [reportMergeResult, setReportMergeResult] = useState({
        success: 0,
        fail: 0
    });
    const [filter, setFilter] = useState(localStorage.getItem("digilog_rFilter") ? JSON.parse(localStorage.getItem("digilog_rFilter")) : defaultFilter);
    const [startDate, setStartDate] = useState(filter.startDate);
    const [endDate, setEndDate] = useState(filter.endDate);

    // 리포트 생성 내역
    const [reportLogData, setReportLogData] = useState([]);
    const [reportId, setReportId] = useState();
    // (E) state


    // (S) ref
    const filterReportIdRef = useRef();
    const filterPhoneNumRef = useRef();
    const filterUserNameRef = useRef();
    const checkboxRefs = useRef([]);
    // (E) ref

    // (S) react-query
    // 리포트 리스트
    const {data, isError, isLoading, refetch, isRefetching, error} = useQuery({
        queryKey: ['reportList'],
        queryFn: () => {
            return axios("/report/list", {
                method: "POST", 
                data: filter
            }).then((result) => {
                checkboxRefs.current = [];
                const tableBodyArr = [];
                result.data.data.list.forEach((val, idx) => {
                    const isBeforeToday = moment(val.reportTime).isBefore(moment().tz("Asia/Seoul").startOf('day'));
                    
                    console.log(isBeforeToday);

                    tableBodyArr.push([
                        {
                            disabled: val.reportStatus === 0,
                            value: val.reportId 
                        },
                        val.branchName,
                        val.rid,
                        <Link to={`/detail/user/${companyId}/${branchId}/${val.userId}`}
                        onClick={() => {
                            localStorage.setItem("digilog_rFilter", JSON.stringify(filter));
                        }}>
                            {masking(val.userName, "name")}
                        </Link>,
                        masking(val.birth, "birth"),
                        masking(val.userPhone, "phone"), 
                        val.reportTime,
                        <div className="btn link-primary text-decoration-underline"
                        onClick={() => {
                            setReportId(val.reportId);
                            setShowPdfHistoryModal(true);
                        }}>{val.printCount}</div>,
                        <>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                val.reportStatus === 0 ? (
                                  isBeforeToday ? (
                                    <Tooltip>
                                      리포트 생성 시 오류가 발생하여 재촬영이 필요합니다. 오류 리포트는 PDF 생성 및 보기가 불가능합니다.
                                    </Tooltip>
                                  ) : (
                                    <Tooltip>
                                      현재 리포트 이미지를 처리하고있습니다. 조금만 기다려주세요.
                                    </Tooltip>
                                  )
                                ) : <></>
                              }
                        >
                            {
                                val.reportStatus === 0 ? (
                                    isBeforeToday ?
                                    <div className="btn-sm btn-danger badge opacity-50">
                                        오류
                                    </div>
                                :  
                                <div className="btn-sm btn-dark badge opacity-50">
                                    대기중
                                </div> 
                            ) :
                                <div className="btn-sm btn-dark badge cursor-pointer" onClick={() => {
                                    setShowPdfModal(true);
                                    setReportId(val.reportId);
                                }}>
                                    보기
                                </div>
                            }
                        </OverlayTrigger>
                        </>,
                        <svg onClick={() => {
                            dispatch(showConfirm({
                                msg: "정말 삭제하시겠어요?",
                                btnText: "삭제",
                                func: () => {
                                    setReportId(val.reportId);
                                    reportDeleteQuery.mutate();
                                    dispatch(hideConfirm());
                                }
                            }));
                        }} className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                        </svg>
                    ]);
                });
    
                setTableData({
                    ...tableData,
                    total: result.data.data.total,
                    body: tableBodyArr
                });

                return result.data;
            })
        },
        enabled: false,
        refetchInterval: 60000,
    });

    // 리포트 보기
    const viewReportQuery = useQuery({
        queryKey: ['reportView'],
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        retry: false,
        queryFn: () => {
            return axios("/report/view", {
                method: "POST",
                data: {
                    id: reportId,
                    password: reportPw
                }
            }).then(result => {
                setReportPw("");
                setShowPdfModal(false);
                window.open(result.data.data.reportUrl);
                return result.data;
            }).catch(e => {
                dispatch(showAlert({
                    msg: e.response.data.msg.ko
                }))
            });
        },
        enabled: false
    });
    
    // 리포트 삭제
    const reportDeleteQuery = useMutation({
        mutationKey: ['reportDelete'],
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        mutationFn: async () => {
            const result = await axios("/report/delete/" + reportId, {
                method: "DELETE",
            });
            if (result.status == "204") {
                dispatch(showAlert({
                    msg: "삭제가 완료되었습니다.",
                    func: () => { refetch(); }
                }));
            } else {
                throw new Error(result.msg.ko);
            }
            return result.data;
        }
    });
    
    // 리포트 생성 기록
    const reportLogQuery = useQuery({
        queryKey: ['reportLog'],
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        queryFn: () => {
            return axios("/report/log/" + reportId, {
                method: "GET",
            }).then(result => {
                const arr = [];
                result.data.data.logTime.forEach((el, idx) => {
                    arr.push([result.data.data.logTime.length - idx, el]);
                });
                
                setReportLogData(arr);

                return result.data;
            })
        },
        enabled: !!showPdfHistoryModal
    });

    // 리포트 병합
    const reportMergeQuery = useQuery({
        queryKey: ['reportMerge'],
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        queryFn: () => {
            return axios("/report/combine/", {
                method: "POST",
                data: {
                    idList: reportMergeArr
                }
            }).then(async result => {
                let success = 0;
                let fail = 0;
                // 초기화
                setReportMergeTable([]);
                setReportMergeResult({
                    ...reportMergeResult,
                    success: 0,
                    fail: 0,
                })
                if (result.data.code == 0) {
                    merger.reset();

                    const mergeDataRev = result.data.data.reverse();
                    for (const el of mergeDataRev) {
                        try {
                            await merger.add(el.reportUrl);
                            success++;
                        } catch (e) {
                            fail++;
                            setReportMergeTable(prev => [...prev, [el.reportId, el.userName, <span className="text-danger">실패</span>]]);
                        }
                    }


                    // 모든 작업이 완료된 후 reportMergeResult를 업데이트
                    setReportMergeResult({
                        ...reportMergeResult,
                        success: success,
                        fail: fail,
                    });

                    // 모든 작업이 완료된 후 추가 작업 수행
                    setLoading(false);
                    setShowReadyPrintModal(true);
                }
                
                return result.data;
            }).catch(error => {
                setLoading(false);
                dispatch(showAlert({
                    msg: <>처리 중 오류가 발생했습니다.<br/>잠시 후 다시 시도해주세요.</>
                }))
            });
        },
        enabled: false
    });

    // 리포트 생성 기록 등록
    const reportLogMutation = useMutation({
        mutationKey: ['addReportLog'],
        mutationFn: (file) => {
            return axios("/report/log/add", {
                method: "POST",
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: {
                    combinePdfFile: file,
                    idList: reportMergeArr
                }
            }).then(result => {
                if (result.status == "201") {
                    window.open(result.data.data);
                    setShowReadyPrintModal(false);
                    refetch();
                } else {
                    throw new Error();
                }

                return result.data;
            }).catch(e => {
                dispatch(showAlert({
                    msg: "요청을 처리하지 못했습니다."
                }))
            }).then(() => {
                setLoading(false);
                setReportMergeArr([]);
            });
        },
    });
    // (E) react-query


    // 리포트 생성
    const handleClickMerge = async () => {
        if (reportMergeArr.length > 0) {
            setLoading(true);
            reportMergeQuery.refetch();
        } else {
            dispatch(showAlert({
                msg: "선택한 항목이 없습니다."
            }))
        }
    }

    const handleClickMakePdf = async () => {
        await merger.setMetadata({
            producer: "pdf-merger-js based script",
            title: moment().format("YYYY-MM-DD") + "_DIGILOG_REPORT"
        });
        
        const mergedPdf = await merger.saveAsBlob();
        // window.open(URL.createObjectURL(mergedPdf))
        setLoading(true);
        reportLogMutation.mutate(mergedPdf);
    }

    useEffect(() => {
        if (checkAllRef.current) {
            checkAllRef.current.checked = false;
        }
        refetch();
    },[filter]);

    useEffect(() => {
        let enterFunc;
        if (showPdfModal) {
            enterFunc = (e) => {
                if (e.keyCode == 13) {
                    if (reportPw) {
                        viewReportQuery.refetch();
                    } else {
                        dispatch(showAlert({
                            msg: "비밀번호를 입력해주세요."
                        }))
                    }
                }
            }
            document.addEventListener("keyup", enterFunc)
        }

        return () => {
            document.removeEventListener("keyup", enterFunc)
        }
    },[showPdfModal, reportPw]);
    
    useEffect(() => {
        refetch();
    },[location])

    useEffect(() => {
        localStorage.removeItem("digilog_rFilter");
    },[])

    if (isError) {
        if (error.response) {
            return <div>{error.response.data.msg.ko}</div>
        }
    }

    return (
        <>

            {
                loading && <Loading layer={true} />
            }

            <TableFilterBox
                handleClickReset={() => {
                    filterReportIdRef.current.value = "";
                    filterPhoneNumRef.current.value = "";
                    filterUserNameRef.current.value = "";
                    setStartDate(defaultDate[0]);
                    setEndDate(defaultDate[1]);
                    setFilter({
                        ...filter,
                        ...defaultFilter
                    });
                }}
                handleClickSubmit={() => {
                    setFilter({
                        ...filter,
                        page: 1,
                        startDate: startDate,
                        endDate: endDate,
                        reportId: filterReportIdRef.current.value,
                        userPhone: filterPhoneNumRef.current.value,
                        userName: filterUserNameRef.current.value
                    });
                    
                }}>
                <Row className="justify-content-between">
                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                리포트 ID
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <Form.Control 
                                    ref={filterReportIdRef} 
                                    type="text" 
                                    placeholder="리포트 ID를 입력하세요." 
                                    defaultValue={filter.reportId}
                                />
                            </Col>
                        </Form.Group>
                    </Col>

                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                휴대폰번호
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <Form.Control 
                                    ref={filterPhoneNumRef} 
                                    type="text" 
                                    placeholder="휴대폰번호를 입력하세요" 
                                    defaultValue={filter.userPhone}
                                    onInput={(e) => {
                                        e.target.value = onlyNumber(e.target.value);
                                    }}
                                />
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mt-4 justify-content-between">
                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                이름
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <Form.Control 
                                    ref={filterUserNameRef} 
                                    type="text" 
                                    placeholder="이름을 입력하세요" 
                                    defaultValue={filter.userName}
                                />
                            </Col>
                        </Form.Group>
                    </Col>

                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                측정일
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <DatepickerRange 
                                    startDate={startDate} endDate={endDate} 
                                    onChange={(dates) => {
                                        setStartDate(dates[0]);
                                        setEndDate(dates[1]);
                                    }} 
                                />
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
            </TableFilterBox>

            <TableWrap className="mt-4">
                {
                    data &&
                    <TableHeader total={data.data.total}>
                        <div style={{width: "200px"}}>
                            <SelectBox 
                                onChange={(value) => {
                                    setFilter({
                                        ...filter,
                                        page: 1,
                                        perPage: value.value
                                    })
                                }} 
                                className="w-auto"
                                defaultValue={filter.perPage}
                                data={perPageOptions}
                            />
                        </div>
                        <TableHeader.ButtonBox>
                            <Button variant="primary" onClick={handleClickMerge}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/>
                                </svg>
                                PDF 생성
                            </Button>
                        </TableHeader.ButtonBox>
                    </TableHeader>
                }

                <DataTable isError={isError}
                            isLoading={isLoading || isRefetching}
                            data={tableData} sort={[5]} activeSortIdx={5}  
                            useNo={true}
                            useCheckbox={true}
                            page={filter.page}
                            perPage={filter.perPage}
                            setCheckboxVal={setReportMergeArr}
                            handleClickSort={(idx, type) => {
                                setFilter({
                                    ...filter,
                                    orderField: tableData.orderField[idx],
                                    order: type,
                                })
                            }} 
                />

                {
                    data && 
                    <TableFooter>
                        <TablePagination 
                        total={data.data.total} 
                        perPage={filter.perPage} 
                        currentPage={filter.page}
                        onChange={(value) => {
                            setFilter({
                                ...filter,
                                page: value
                            })
                        }}/>
                    </TableFooter>
                }
            </TableWrap>

            {/* PDF 병합 결과 */}
            <Modal 
                backdrop="static"
                show={showReadyPrintModal} centered size="lg" 
                onHide={() => {
                    setShowReadyPrintModal(false);
                    setReportMergeTable([]);
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>PDF 병합 결과</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-3">
                        PDF 병합 결과가 다음과 같습니다. (<span className="text-primary fw-bold">성공</span> <span className="fw-bold">{reportMergeResult.success}</span>건 / <span className="text-danger fw-bold">실패</span> <span className="fw-bold">{reportMergeResult.fail}</span>건)
                    </p>

                    <div className="table-wrap overflow-auto custom-scroll" style={{ maxHeight: "500px" }}>
                        <DataTable
                            useNo={true}
                            isLoading={reportMergeQuery.isLoading}
                            stickyHeader
                            emptyDataMsg="전체 데이터 병합에 성공하였습니다."
                            data={{
                                head: ["리포트 ID", "이름", "상태"],
                                body: reportMergeTable.reverse(),
                            }}
                        />
                    </div>

                    <p className="mt-4">
                        
                        <small className="text-secondary small" style={{lineHeight: 1.5}}>
                            *준비 상태가 실패인 리포트는 PDF에 병합되지 못한 리포트입니다.
                            <br/>
                            *전체 취소 후 재시도 혹은 해당 건만 다시 시도해 보시길 바랍니다.
                        </small>
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={() => {setShowReadyPrintModal(false)}}>취소</Button>
                    <Button onClick={() => {handleClickMakePdf()}}>PDF 생성</Button>
                </Modal.Footer>
            </Modal>

            {/* PDF 생성 이력 */}
            <Modal show={showPdfHistoryModal} centered size="md" onHide={() => {setShowPdfHistoryModal(false)}}>
                <Modal.Header closeButton>
                    <Modal.Title>PDF 생성 이력</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        (reportLogQuery.isLoading || reportLogQuery.isRefetching) 
                        ? 
                        <Loading/>
                        : 
                        reportLogQuery.data &&
                        <>
                        <p className="mb-3">
                            리포트 ID {reportLogQuery.data.data.rid}
                        </p>
                        <div className="position-relative table-wrap overflow-auto custom-scroll" style={{ height: "500px" }}>
                            <DataTable
                                stickyHeader
                                data={{
                                    head: ["No", "생성일시"],
                                    body: reportLogData
                                }}
                            />
                        </div>
                        </>
                    }

                    <p className="mt-4">
                        <small className="text-secondary small" style={{lineHeight: 1.5}}>
                            *본 이력은 PDF 생성 버튼 클릭 기준으로 히스토리를 누적합니다. 
                            <br/>따라서 실제 인쇄 여부와 일치하지 않을 수 있습니다.
                        </small>
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => {
                        setShowPdfHistoryModal(false);
                    }}>닫기</Button>
                </Modal.Footer>
            </Modal>

            {/* 비밀번호 입력 */}
            <Modal show={showPdfModal} centered size="sm" onHide={() => {setShowPdfModal(false)}}>
                <Modal.Header closeButton>
                    <Modal.Title>PDF 보기</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <InputGroup>
                        <InputGroup.Text>비밀번호</InputGroup.Text>
                        <Form.Control 
                            onInput={(e) => {
                                setReportPw(e.target.value)
                            }}/>
                    </InputGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={() => {
                        setShowPdfModal(false);
                    }}>취소</Button>
                    <Button variant="primary" onClick={() => {
                        if (reportPw) {
                            viewReportQuery.refetch();
                        } else {
                            dispatch(showAlert({
                                msg: "비밀번호를 입력해주세요."
                            }))
                        }
                    }}>확인</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default ReportManagement;
